import {
  AvcorePublishStreamApiCredentials,
  StreamId,
  StreamKind
} from "@common/domain";
import { createAction, props } from "@ngrx/store";
import { TypedAction } from "@ngrx/store/src/models";
import { Subject } from "rxjs";
import { LocalAnyConferenceStream } from "youm-lib/conference";

const STREAM_ADD_TYPE = "[Local Conference Stream] Stream Add" as const;

export const streamAdd = Object.assign(
  (props: {
    stream: LocalAnyConferenceStream;
    kinds: StreamKind[];
    credentials: AvcorePublishStreamApiCredentials;
  }) => {
    const action = {
      ...props,
      type: STREAM_ADD_TYPE
    };

    streamAdd.actions$.next(action);

    return action;
  },
  {
    type: STREAM_ADD_TYPE,
    // Overcome "Cannot assign to read only property 'macroTask'" on a 'stream'field (strictActionImmutability)
    actions$: new Subject<StreamAdd>()
  }
);

// The stream could not be published (error or timeout), it was destroyed.
export const streamAddFailure = createAction(
  "[Local Conference Stream] Stream Add Failure",
  props<{ id: StreamId; error: string }>()
);

export const streamDelete = createAction(
  "[Local Conference Stream] Stream Delete",
  props<{ id: StreamId }>()
);

export const dispose = createAction("[Local Conference Stream] Dispose");

export type StreamAdd = {
  stream: LocalAnyConferenceStream;
  kinds: StreamKind[];
  credentials: AvcorePublishStreamApiCredentials;
} & TypedAction<typeof streamAdd.type>;
